module.exports = __webpack_public_path__ + "img/ico_error_page.c656f233.svg";